import React from 'react';

const CorporateTrainingsPage = () => {
  return <div>CorporateTrainingsPage</div>;
};

export default CorporateTrainingsPage;
